import React, { FC, ReactElement } from "react";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";

import { PplRule } from "../../../store/pomeriumApi";

interface AddProps {
  readonly: boolean;
  pplArr: PplRule[];
  savePPL(value: PplRule[]): void;
}
const AddAllowDeny: FC<AddProps> = ({
  readonly,
  pplArr,
  savePPL,
}): ReactElement => {
  return (
    <Grid container>
      <Grid size={12}>
        <Button
          sx={{
            top: "50%",
            height: 30,
            float: "right",
            position: "relative",
            transform: "translateY(-50%)",
            marginLeft: 1,
          }}
          variant={"contained"}
          style={
            readonly
              ? {}
              : {
                  fontSize: 15,
                  backgroundColor: "#4CAF50",
                  color: "#FFFFFF",
                }
          }
          startIcon={<AddCircleOutlineIcon />}
          children={"Add Allow Block"}
          onClick={() => {
            const arr = [...pplArr, { allow: {} }];
            savePPL(arr);
          }}
          disabled={readonly}
        />
        <Button
          sx={{
            top: "50%",
            height: 30,
            float: "right",
            position: "relative",
            transform: "translateY(-50%)",
            marginLeft: 1,
          }}
          variant={"contained"}
          style={
            readonly
              ? {}
              : {
                  fontSize: 15,
                  backgroundColor: "#F44336",
                  color: "#FFFFFF",
                }
          }
          startIcon={<AddCircleOutlineIcon />}
          children={"Add Deny Block"}
          onClick={() => {
            const arr = [...pplArr, { deny: {} }];
            savePPL(arr);
          }}
          disabled={readonly}
        />
      </Grid>
    </Grid>
  );
};

export default AddAllowDeny;
